(function () {
  'use strict';

  /* @ngdoc object
   * @name events.deposits.edit
   * @description
   *
   */
  angular
    .module('events.deposits.edit', [
      'ui.router'
    ]);
}());
